import React from "react";
import { observer } from "mobx-react";
import { TerritoryCreateStore } from "../../store";
import { TerritoryCreateForm } from "./TerritoryCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type TerritoryCreateProps = {
  territoryCreateStore: TerritoryCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TerritoryCreate: React.FC<TerritoryCreateProps> = observer(
  ({ territoryCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={territoryCreateStore.isSaving} />
        <TerritoryCreateForm
          territoryCreateStore={territoryCreateStore}
          name_esError={territoryCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            territoryCreateStore.setName_esValue(value);
          }}
          name_es={territoryCreateStore.entityValues.name_es}
          name_enError={territoryCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            territoryCreateStore.setName_enValue(value);
          }}
          name_en={territoryCreateStore.entityValues.name_en}
          name_ptError={territoryCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            territoryCreateStore.setName_ptValue(value);
          }}
          name_pt={territoryCreateStore.entityValues.name_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={territoryCreateStore.isProcessing}
          onSave={() => territoryCreateStore.saveNewTerritory()}
          onCancel={() => territoryCreateStore.cancelNewTerritory()}
        />
        <ErrorDialog
          open={territoryCreateStore.errorDialogOpened}
          title={territoryCreateStore.errorTitle}
          description={territoryCreateStore.errorDescription}
          onClose={() => territoryCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
